import { useEffect, useState, useRef, useContext } from 'react';
import '../../../styles/game/GameBoard.css';


function BgSun({isRotating, isAnimationOn}) {

    const containerRef = useRef(null);
    const [imageWidth, setImageWidth] = useState(0);
    
    useEffect(() => {
        const updateImageWidth = () => {
            if (containerRef.current) {
              const containerWidth = containerRef.current.offsetWidth;
              setImageWidth(containerWidth * 4); // Умножаем ширину контейнера на 2
            }
          };

          updateImageWidth();
          window.addEventListener("resize", updateImageWidth);

          return () => {
            window.removeEventListener("resize", updateImageWidth);
          };
    }, [])

    return (
        <>
            
                <div className={"bg-sun-wrapper"} ref={containerRef}>
                    
                <img
    src="/assets/img/bg-sun.svg" // Замените на ваш URL изображения
    alt="Rotating"
    style={{
        width: `${imageWidth}px`,
        animation: "rotate 40s linear infinite",
        animationPlayState: (isRotating && isAnimationOn) ? "running" : "paused",
    }}
    className="rotating-image"
/>
      
                </div>
            
        </>
    )
}

export default BgSun;